// MT home dashboard (zone layout) strings: mtdToday. Keys use the "mtd-" prefix.
// Shared words (today, sales, service, labor, metric, comp, close, no-data,
// rankings) and the shell's mtd-full-report are reused
// from their existing domains rather than copied here.
export default {
  en: {
    'mtd-today-meta': 'Live · every {minutes} min',
    'mtd-today-meta-updated': 'Live · every {minutes} min · updated {time}',
    'mtd-vs-ly': 'vs LY',
    'mtd-today-since-open': 'Since open',
    'mtd-today-meta-next':
      'Live · every {minutes} min · updated {time} · next in {next} min',
    'mtd-today-latest-hour': 'Latest hour',
    'mtd-today-change-since': '{change} since {time}',
    'mtd-metric-count': '{count} of {max}',
    'mtd-metric-cap':
      'Up to {max} metrics per section. Turn one off to pick another.',
  },
  es: {
    'mtd-today-meta': 'En vivo · cada {minutes} min',
    'mtd-today-meta-updated':
      'En vivo · cada {minutes} min · actualizado {time}',
    'mtd-vs-ly': 'vs AA',
    'mtd-today-since-open': 'Desde la apertura',
    'mtd-today-meta-next':
      'En vivo · cada {minutes} min · actualizado {time} · próxima en {next} min',
    'mtd-today-latest-hour': 'Última hora',
    'mtd-today-change-since': '{change} desde las {time}',
    'mtd-metric-count': '{count} de {max}',
    'mtd-metric-cap':
      'Hasta {max} métricas por sección. Desactive una para elegir otra.',
  },
  fr: {
    'mtd-today-meta': 'En direct · toutes les {minutes} min',
    'mtd-today-meta-updated':
      'En direct · toutes les {minutes} min · mis à jour {time}',
    'mtd-vs-ly': 'vs AD',
    'mtd-today-since-open': "Depuis l'ouverture",
    'mtd-today-meta-next':
      'En direct · toutes les {minutes} min · mis à jour {time} · prochaine dans {next} min',
    'mtd-today-latest-hour': 'Dernière heure',
    'mtd-today-change-since': '{change} depuis {time}',
    'mtd-metric-count': '{count} sur {max}',
    'mtd-metric-cap':
      "Jusqu'à {max} indicateurs par section. Désactivez-en un pour en choisir un autre.",
  },
  'fr-ca': {
    'mtd-today-meta': 'En direct · toutes les {minutes} min',
    'mtd-today-meta-updated':
      'En direct · toutes les {minutes} min · mis à jour {time}',
    'mtd-vs-ly': 'vs AD',
    'mtd-today-since-open': "Depuis l'ouverture",
    'mtd-today-meta-next':
      'En direct · toutes les {minutes} min · mis à jour {time} · prochaine dans {next} min',
    'mtd-today-latest-hour': 'Dernière heure',
    'mtd-today-change-since': '{change} depuis {time}',
    'mtd-metric-count': '{count} sur {max}',
    'mtd-metric-cap':
      "Jusqu'à {max} indicateurs par section. Désactivez-en un pour en choisir un autre.",
  },
};
